export enum ProductCode {
  EGIB = 'BPT',
  EGTB = 'TPT',
  ELGAP = 'PNT',
}

export enum ProductId {
  EGIB = 1,
  EGTB = 2,
  ELGAP = 3,
}
